export const environment = {
  production: false,
  api: 'https://api-dev.agrotransparencia.com.br',
  gpaUrl: 'https://safetrace.qualidadepereciveis.com.br'
};
